module.exports = __webpack_public_path__ + "static/media/ThumbnailStill11.7c5781ad.png";